<template>
  <div class="company">
    <div class="all-title">
      {{pageData.title}}
    </div>
    <div class="company-main">
      <ul>
        <li v-for="iten in pageData.companyDets">
          <span>{{iten.label}}</span><span>{{iten.content}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        resDatas:''
      }
    },
    computed: {
      pageData() {
        return this.$store.state.languagesData.company;
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
          this.resDatas=newData;
        }
    },
    mounted() {
      this.$store.commit("highLighted",this.$route.name);
    }
  }
</script>

<style scoped>
  .company-main{
    width: 50%;
    margin: auto;
  }
  .company .title{
    font-size: 22px;
    padding: 3%;
    font-weight: 600;
    text-align: center;
  }
  .company-main{
    margin-top: 3%;
  }
  .company-main li{
    display: block;
    padding: 2%;
    font-size: 0;
    box-sizing: border-box;
  }
  .company-main li:nth-of-type(2n+1){
    background-color: #EBEBEB;
  }
  .company-main li span{
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    vertical-align: middle;
    word-break: break-all;
    box-sizing: border-box;
  }
  .company-main li span:nth-of-type(1){
    width: 34%;
    text-align: center;
  }
  .company-main li span:nth-of-type(2){
    width: 66%;
    color: #818181;
    padding: 0 1%;
  }
  @media screen and (max-width: 1000px){
    .company-main{
      width: 90%;
      margin:5% auto 0;
    }
    .company-main li{
      padding: 1.5% 0;
    }
    .company-main li span{
      font-size: 18px;
    }
    .company-main li span:nth-of-type(1){
      padding: 0 1.5%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/company.vue